var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "playlist__card card" },
    [
      _c(
        "PlaylistCardImageGrid",
        { staticClass: "stick-all-corners", attrs: { images: _vm.images } },
        [
          _c(
            "div",
            {
              staticClass: "playlist__empty-indicator stylized",
              attrs: { slot: "empty" },
              slot: "empty"
            },
            [
              _c("div", { staticClass: "cap-first" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.$t("playlist.card.empty", {
                        item: _vm.$t("playlist.label", { count: 0 })
                      })
                    ) +
                    "\n      "
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "\n        playlist__side-overlay stylized\n        text-center flex-column\n        stick-top-left\n      ",
              class: _vm.playlist.isPrivate ? "is-private" : "",
              attrs: { slot: "side", to: "/playlists/" + _vm.playlist.slug },
              slot: "side"
            },
            [
              _c("div", { staticClass: "side-overlay__count" }, [
                _vm._v(
                  "\n        " + _vm._s(_vm.playlist.videoCount) + "\n      "
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "side-overlay__item" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.$t("playlist.card.film", {
                        count: _vm.playlist.videoCount
                      })
                    ) +
                    "\n      "
                )
              ]),
              _vm._v(" "),
              _c("i", {
                staticClass: "material-icons side-overlay__open-arrow",
                attrs: { "data-icon": "chevron_right" }
              })
            ]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }